import { RECEIVE_FEATURES } from '../constants/ActionTypes';

const licenseFeatures = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_FEATURES:
      return action.payload;
    default:
      return state;
  }
}

export default licenseFeatures;



// WEBPACK FOOTER //
// ./src/reducers/features.js